import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { SCAFFOLDING, CARDS } from 'theme';

const propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    onClick: null,
};

const CardSectionCSS = css`
    position: relative;
    width: 100%;
    padding: ${CARDS.GUTTER};

    * + & {
        border-top: 1px solid ${SCAFFOLDING.BORDER_COLOR};
    }
`;

const StyledCardSection = styled.div`
    ${CardSectionCSS}
`;

const StyledCardSectionButton = styled.button`
    ${CardSectionCSS}
    min-height: 5em;
    background: none;
    border: 0;
    text-align: left;
`;

const CardSection = ({ onClick, children, ...props }) => {
    return onClick ? (
        <StyledCardSectionButton onClick={onClick} {...props}>
            {children}
        </StyledCardSectionButton>
    ) : (
        <StyledCardSection {...props}>{children}</StyledCardSection>
    );
};

CardSection.propTypes = propTypes;
CardSection.defaultProps = defaultProps;

export default CardSection;
